import * as React from "react"
import { Area, Route, RoutesOutput } from "../../types/types";
import QuickFilter, { QuickFilterProps } from "../home/components/QuickFilter";
import * as Immutable from 'immutable'
import { replaceWithJsx } from "../../utils/replace";
import { RentalAdvertSnippet } from "../shared/area_theme/RentalAdvertSnippet";
import { LinksToOverview } from "./components/LinksToOverview";
import { LinkListItems } from "../shared/area_theme/LinkListItems";

type Props = {
  area: Area
} & QuickFilterProps

const humanizedGitesCount = (area: Area) : JSX.Element => (
  <a href={area.giteOverviewPath}>
    {I18n.t('areas.count.gite', { count: area.gitesCount, area: area.name } )}
  </a>
)

const humanizedBnbCount = (area: Area) : JSX.Element => (
  <a href={area.bnbOverviewPath}>
    {I18n.t('areas.count.bnb', { count: area.bedAndBreakfastsCount, area: area.name } )}
  </a>
)

const humanizedCount = (area: Area) : JSX.Element => (
  area.gitesCount > 0 && area.bedAndBreakfastsCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.both", { gites: '%gites%', bnb: '%bnb%' } ), Immutable.Map({
      gites: () => humanizedGitesCount(area),
      bnb: () => humanizedBnbCount(area),
    }))
  : area.gitesCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.single", { string: '%gites%' } ), Immutable.Map({
      gites: () => humanizedGitesCount(area),
    }))
  : area.bedAndBreakfastsCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.single", { string: '%bnb%' } ), Immutable.Map({
      bnb: () => humanizedBnbCount(area),
    }))
  : null
)

export const Show = (props: Props) : JSX.Element => (
  <div>
    <div className="hero hero--area">
      <div className="hero__visual" style={{backgroundImage: `url(${props.area.headerImage.url})`}}>
        <img className="hero__image" src={props.area.headerImage.url} />
      </div>
      <div className="search search--home">
        <div className="grid-container">
          <div className="grid-100">
            <QuickFilter
              startDate={props.startDate}
              endDate={props.endDate}
              onFocusChange={(fi) => props.onFocusChange(fi)}
              focusedInput={props.focusedInput}
              onDatesChange={(range) => props.onDatesChange(range)}
              filterDisabled={props.filterDisabled}
              onFilterSubmit={() => props.onFilterSubmit()}
              maxPeople={props.maxPeople}
              onMaxPeopleChange={(i) => props.onMaxPeopleChange(i)}
            />
          </div>
        </div>
      </div>
    </div>
    <div className="page-section page-section--yellow page-section--slim">
      <div className="grid-container home-filters__inner">
        <div className="grid-100 tac">
          <h1 className="page-section__title page-section__title--big">{I18n.t('areas.gites_in', { area: props.area.name})}</h1>
          <p>{humanizedCount(props.area)}</p>
          {
            props.area.gitesCount > 0 ?
              <p>
                <a id="midi-pyrenees_area_top_cta_gite" className="btn btn--ghost-darkblue" href={props.area.giteOverviewPath}>
                  { I18n.t('areas.view_accommodations', { count: props.area.gitesCount })}
                </a>
              </p>
            : ''
          }
        </div>
      </div>
    </div>
    <div className="page-section page-section--pt">
      <div className="grid-container">
        <div className="grid-50 suffix-25 push-25 tablet-grid-70 tablet-suffix-5 tablet-push-25">
          <h2 className="page-section__title">{props.area.bodyTitle}</h2>
          {
            replaceWithJsx(
              props.area.bodyContent,
              Immutable.Map({
                ADVERTS: () => (
                <div className="accommodations accommodations--area">
                  {
                    Immutable.List(props.area.rentalAdverts.nodes).map(x => (
                      <RentalAdvertSnippet rental_advert={x} key={x.id} />
                    ))
                  }
                  <LinksToOverview area={props.area} />
                </div>
              )}),
              (s) => <>{require('html-react-parser')(s)}</>
            )
          }
          {
            props.area.listTitle && props.area.linkListItems ?
              <LinkListItems
                title={props.area.listTitle}
                items={Immutable.List(props.area.linkListItems)}
              />
            : ''
          }
          {
            Immutable.List(props.area.departments.nodes).count() > 0 ?
              <>
                <h3>{I18n.t('areas.departments')}</h3>
                <ul className="link-list">
                  {
                    Immutable.List(props.area.departments.nodes).map(x =>
                      <li className="link-list__item" key={x.id}>
                        <a className="link-list__link" href={x.path}>
                          {x.name}
                        </a>
                      </li>
                    )
                  }
                </ul>
              </>
            : ''
          }
        </div>
        <div className="grid-20 suffix-5 pull-75 tablet-grid-20 tablet-suffix-5 tablet-pull-75 hide-below-tablet-landscape">
          {
            props.area.bodyImage && props.area.bodyImage.exists ?
              <a href={props.area.giteOverviewPath}>
                <img className="fill-image" src={props.area.bodyImage.url} />
              </a>
            : ''
          }
        </div>
      </div>
    </div>
    <div className="page-section">
      <div className="grid-container">
        <div className="grid-100 tac">
          <LinksToOverview area={props.area} />
        </div>
      </div>
    </div>
  </div>
)

